   import React, { useState } from 'react';
   import styled from 'styled-components';
   
   import { useDrag } from 'react-dnd';

const PaletteContainer = styled.div`
    width: 200px;
    background-color: #f8f9fa;
    border-right: 1px solid #e9ecef;
    padding: 15px;
    box-shadow: 2px 0 5px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    border-radius: 8px;
`;

const PaletteTitle = styled.h3`
    margin-top: 0;
    margin-bottom: 15px;
    color: #343a40;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
`;

const PaletteButton = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: #e2e6ea;
    border: 1px solid #dae0e5;
    border-radius: 5px;
    cursor: grab;
    font-size: 0.9em;
    color: #495057;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
    user-select: none; /* Prevent text selection during drag */

    &:hover {
        background-color: #d3d9df;
        border-color: #c8ced3;
    }

    svg {
        width: 30px;
        height: 30px;
        margin-bottom: 5px;
        color: #007bff; /* Example: tint icons blue */
    }
`;

   const CollapsiblePalette = styled('div').withConfig({
	shouldForwardProp: (prop) => !['isOpen'].includes(prop)
	})`
    display: ${props => props.isOpen ? 'flex' : 'none'};
    flex-direction: column;
    gap: 10px;
	`;
   
   const ItemTypes = {
     COMPONENT: 'component',
     PALETTE_COMPONENT: 'palette_component'
 };
 
 const RouterIcon = () => (
 <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z" fill="#1A78C2"/>
  <path d="M32 40C36.4183 40 40 36.4183 40 32C40 27.5817 36.4183 24 32 24C27.5817 24 24 27.5817 24 32C24 36.4183 27.5817 40 32 40Z" fill="white"/>
  <path d="M32 24V40" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
  <path d="M24 32H40" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
</svg>
);

const SwitchIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="12" y="24" width="40" height="16" rx="4" fill="white"/>
  <rect x="16" y="28" width="4" height="4" fill="#1A78C2"/>
  <rect x="24" y="28" width="4" height="4" fill="#1A78C2"/>
  <rect x="32" y="28" width="4" height="4" fill="#1A78C2"/>
  <rect x="40" y="28" width="4" height="4" fill="#1A78C2"/>

  <rect x="16" y="34" width="4" height="4" fill="#1A78C2"/>
  <rect x="24" y="34" width="4" height="4" fill="#1A78C2"/>
  <rect x="32" y="34" width="4" height="4" fill="#1A78C2"/>
  <rect x="40" y="34" width="4" height="4" fill="#1A78C2"/>
</svg>
);

const FirewallIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="16" y="16" width="32" height="32" rx="8" fill="white"/>
  <rect x="20" y="20" width="10" height="8" fill="#1A78C2"/>
  <rect x="34" y="20" width="10" height="8" fill="#1A78C2"/>
  <rect x="20" y="30" width="10" height="8" fill="#1A78C2"/>
  <rect x="34" y="30" width="10" height="8" fill="#1A78C2"/>
  <rect x="20" y="40" width="10" height="8" fill="#1A78C2"/>
  <rect x="34" y="40" width="10" height="8" fill="#1A78C2"/>
</svg>
);

const ServerIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="16" y="16" width="32" height="32" rx="8" fill="white"/>
  <rect x="20" y="22" width="24" height="6" rx="2" fill="#1A78C2"/>
  <rect x="20" y="30" width="24" height="6" rx="2" fill="#1A78C2"/>
  <rect x="20" y="38" width="24" height="6" rx="2" fill="#1A78C2"/>
</svg>
);

const FCSwitchIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="16" y="16" width="32" height="32" rx="8" fill="white"/>
  <path d="M20 24L44 40" stroke="#1A78C2" stroke-width="4" stroke-linecap="round"/>
  <path d="M44 24L20 40" stroke="#1A78C2" stroke-width="4" stroke-linecap="round"/>
  <circle cx="20" cy="24" r="2" fill="#1A78C2"/>
  <circle cx="44" cy="40" r="2" fill="#1A78C2"/>
  <circle cx="44" cy="24" r="2" fill="#1A78C2"/>
  <circle cx="20" cy="40" r="2" fill="#1A78C2"/>
</svg>
);

const NacSystemIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="16" y="16" width="32" height="32" rx="8" fill="white"/>
  <path d="M32 20L20 28V36C20 42.6 25.12 48 32 48C38.88 48 44 42.6 44 36V28L32 20Z" fill="#1A78C2"/>
  <path d="M24 24L20 20" stroke="white" stroke-width="2" stroke-linecap="round"/>
  <path d="M40 24L44 20" stroke="white" stroke-width="2" stroke-linecap="round"/>
  <path d="M24 40L20 44" stroke="white" stroke-width="2" stroke-linecap="round"/>
  <path d="M40 40L44 44" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>
);

const StorageDeviceIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="16" y="16" width="32" height="32" rx="8" fill="white"/>
  <rect x="20" y="20" width="24" height="8" rx="2" fill="#1A78C2"/>
  <rect x="20" y="30" width="24" height="8" rx="2" fill="#1A78C2"/>
  <rect x="20" y="40" width="24" height="8" rx="2" fill="#1A78C2"/>
</svg>
);

const LoadBalancerIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="8" fill="#1A78C2"/>
  <rect x="16" y="16" width="32" height="32" rx="8" fill="white"/>
  <path d="M20 32H44" stroke="#1A78C2" stroke-width="4" stroke-linecap="round"/>
  <path d="M38 26L44 32L38 38" stroke="#1A78C2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M28 32C28 30 28 28 30 26" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
  <path d="M28 32C28 34 28 36 30 38" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
</svg>
);


const ConnectionItemIcon = () => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
);

const PcHostIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="10" y="10" width="44" height="30" rx="3" fill="#1A78C2"/>
  <rect x="12" y="12" width="40" height="26" rx="2" fill="white"/>
  <rect x="28" y="40" width="8" height="6" fill="#1A78C2"/>
  <rect x="22" y="46" width="20" height="4" rx="1" fill="#1A78C2"/>
  <rect x="18" y="52" width="28" height="3" rx="0.5" fill="#1A78C2"/>
</svg>
);

const MobileDeviceIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="20" y="5" width="24" height="54" rx="5" fill="#1A78C2"/>
  <rect x="22" y="8" width="20" height="48" rx="3" fill="white"/>
  <circle cx="32" cy="53" r="1.5" fill="#1A78C2"/>
</svg>
);

const IoTDeviceIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="20" y="20" width="24" height="24" rx="4" fill="#1A78C2"/>
  <rect x="23" y="23" width="18" height="18" rx="2" fill="white"/>
  <path d="M32 18C37.5228 18 42 22.4772 42 28" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
  <path d="M32 14C39.732 14 46 20.268 46 28" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
  <path d="M32 10C41.9806 10 50 18.0194 50 28" stroke="#1A78C2" stroke-width="2" stroke-linecap="round"/>
</svg>
);

const PrinterIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="12" y="20" width="40" height="28" rx="3" fill="#1A78C2"/>
  <path d="M15 20L15 15L48 15L48 20L15 20Z" fill="white"/>
  <rect x="15" y="44" width="34" height="4" fill="white"/>
  <rect x="42" y="23" width="7" height="4" rx="1" fill="white"/>
</svg>
);

const IpPhoneIcon = () => (
<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="15" y="25" width="34" height="24" rx="3" fill="#1A78C2"/>
  <rect x="18" y="28" width="12" height="18" rx="2" fill="white"/>
  <path d="M35 15C35 10 30 10 30 10L25 10C25 10 20 10 20 15L20 20C20 25 25 25 25 25L30 25C30 25 35 25 35 20V15Z" fill="#1A78C2"/>
  <rect x="22" y="12" width="11" height="2" fill="white"/>
  <rect x="22" y="20" width="11" height="2" fill="white"/>
</svg>
);

// Map of component types to their SVG components
const paletteIcons = {
    Router: RouterIcon,
    Switch: SwitchIcon,
    Firewall: FirewallIcon,
    Server: ServerIcon,
    FCSwitch: FCSwitchIcon,
    NacSystem: NacSystemIcon,
    StorageDevice: StorageDeviceIcon,
    Load_Balancer: LoadBalancerIcon, 
	PcHost: PcHostIcon,
	MobileDevice: MobileDeviceIcon,
	IoTDevice: IoTDeviceIcon,
	Printer: PrinterIcon,
	IpPhone: IpPhoneIcon,
	
};
 
 
const DraggablePaletteItem = ({ componentType, onAddComponent }) => {
    const Icon = paletteIcons[componentType] || ServerIcon; // Get the appropriate SVG icon component

    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.PALETTE_COMPONENT,
        item: { componentType, width: 80, height: 60 }, // Pass fixed dimensions
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));
    
    // Handle click event for adding component
    const handleClick = () => {
        if (onAddComponent) {
            // These can be adjusted, e.g., to appear at a fixed spot or center of canvas
            onAddComponent(componentType, 100, 100, `${componentType}`); // Label will be the componentType initially
        }
    };
    
    return (
        <PaletteButton ref={drag} style={{ opacity: isDragging ? 0.5 : 1 }} onClick={handleClick} >
            <Icon /> {/* Render the SVG component here */}
            {componentType}
        </PaletteButton>
    );
};

   function ComponentPalette({ onAddComponent }) {
     const [isOpen, setIsOpen] = useState(true);
	 
	 const togglePalette = () => {
         setIsOpen(!isOpen);
     };
 
    return (
        <PaletteContainer>
            <PaletteTitle onClick={togglePalette} style={{ cursor: 'pointer' }}>
            </PaletteTitle>
            <CollapsiblePalette isOpen={isOpen}>
                <DraggablePaletteItem componentType="Router" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="Switch" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="Firewall" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="Server" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="FCSwitch" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="NacSystem" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="StorageDevice" onAddComponent={onAddComponent} />
                <DraggablePaletteItem componentType="Load_Balancer" onAddComponent={onAddComponent} />
				<DraggablePaletteItem componentType="PcHost" onAddComponent={onAddComponent} />
				<DraggablePaletteItem componentType="MobileDevice" onAddComponent={onAddComponent} />
				<DraggablePaletteItem componentType="IoTDevice" onAddComponent={onAddComponent} />
				<DraggablePaletteItem componentType="Printer" onAddComponent={onAddComponent} />
				<DraggablePaletteItem componentType="IpPhone" onAddComponent={onAddComponent} />
            </CollapsiblePalette>
        </PaletteContainer>
    );
 }
 

export default React.memo(ComponentPalette);